import React from "react";

interface ITabData {
  id: string;
  label: string;
  icon: React.ElementType;
}

interface TabProps {
  tabs: ITabData[];
  active: string;
  setActiveTab: (id: string) => void;
}

export const Tab: React.FC<TabProps> = ({ tabs, active, setActiveTab }) => {
  return (
    <div className=" border-gray-200">
      <div className="flex space-x-6 px-4 overflow-x-scroll whitespace-nowrap sm:overflow-x-auto md:overflow-visible">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              onClick={() => setActiveTab(tab.id)}
              key={tab.id}
              className={`flex items-center space-x-1.5 py-2.5 border-b-2 font-medium text-xs transition-colors shrink-0 ${
                active === tab.id
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              <Icon className="w-3.5 h-3.5" />
              <span className="whitespace-nowrap">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
